import { ApolloClient } from '@apollo/client/core'

import { apolloClientOptions } from './apolloClientOptions'
import genericErrorLink from './genericErrorLink'
import hygraphHttpLink from './hygraphHttpLink'

export const hygraphApolloClient = new ApolloClient({
  ...apolloClientOptions,
  link: genericErrorLink.concat(hygraphHttpLink),
  devtools: {
    enabled: process.env.NODE_ENV === 'development',
  },
})
